import { render, staticRenderFns } from "./SubastaView.vue?vue&type=template&id=55e2ff38"
import script from "./SubastaView.vue?vue&type=script&lang=js"
export * from "./SubastaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports